import { IS_SSR } from '../constants';

export const getOrigin = (nextHeaders?: Headers) => {
    let origin = '';

    if (!IS_SSR) {
        origin = window.location.origin;
    } else if (nextHeaders) {
        const host = nextHeaders.get('host');
        const xHost = nextHeaders.get('x-host');

        let hostURL = host || xHost;

        if (hostURL) {
            hostURL = hostURL.replace(/^https?:\/\//, '');

            const protocol = hostURL.includes('localhost:') || hostURL.includes('127.0.0.1') ? 'http' : 'https';

            origin = `${protocol}://${hostURL}`;
        }

        if (origin === '') {
            console.warn('[getOrigin] could not resolve origin based on the headers provided', {
                host,
                xHost,
            });
        }
    }

    return origin;
};
